export async function getRecommendations(shows, userRatings, preferences, idToken) {
  const res = await fetch('/api/recommendations', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`,
    },
    body: JSON.stringify({ shows, userRatings, preferences }),
  });

  if (res.status === 401) throw new Error('Session expired — please sign in again.');

  if (res.status === 429) {
    throw new Error("The Butler has exhausted his daily consultation allowance. He shall be at your service again tomorrow.");
  }

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `Request failed (${res.status})`);
  }

  return res.json();
}
